import type { ConfluenceEmbed } from '../../types';

export const isConfluenceEmbed = (entity: any): entity is ConfluenceEmbed => {
	return entity.__typename === 'ConfluenceEmbed';
};

export const getConfluenceEmbedLink = (embed: ConfluenceEmbed): string | null => {
	const { base, webUi } = embed.links ?? {};

	if (base === undefined || webUi === undefined || base.length === 0 || webUi.length === 0) {
		return null;
	}

	return `${base}${webUi}`;
};
